import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";

export default function AboutPage() {
  return (
    <>
      <SEO title="About" description="About Finance Topia — independent, editorial-grade finance and investing journalism." url="/about" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "About" }]} />
        <header className="border-b-2 border-foreground pb-6 mt-4">
          <div className="overline">About</div>
          <h1 className="font-display font-black text-5xl md:text-6xl mt-2 tracking-tight">
            Finance Topia.
          </h1>
        </header>
        <div className="prose-article mt-10">
          <p>
            Finance Topia is an independent finance and investing publication founded on a simple premise:
            the majority of financial media exists to sell products, not to educate. We aim to be different.
          </p>
          <p>
            Our editorial standards are modeled on the frameworks used by CFA charterholders and buy-side research analysts.
            Every article is grounded in verifiable data, historical precedent, and — where relevant — established academic finance.
            We do not accept sponsored content, we do not accept "guest posts" from paid contributors, and we do not promote
            any specific broker, fund manager, or coin.
          </p>
          <h2 className="font-display text-3xl font-black mt-10 mb-4">Editorial Standards</h2>
          <p>
            All articles are written or reviewed by contributors with formal training in finance,
            economics, or investment management. Where we cite statistics, we favor primary sources
            such as the U.S. Bureau of Labor Statistics, the Federal Reserve, the IMF, and peer-reviewed
            academic journals.
          </p>
          <h2 className="font-display text-3xl font-black mt-10 mb-4">Not Investment Advice</h2>
          <p>
            Finance Topia publishes educational content only. Nothing on this site constitutes
            individualized investment advice, tax advice, or a solicitation to buy or sell any security.
            Always consult a qualified fiduciary advisor before making financial decisions.
          </p>
          <h2 className="font-display text-3xl font-black mt-10 mb-4">Our Six Desks</h2>
          <p>
            We publish across six editorial desks: Investing, Personal Finance, Cryptocurrency,
            Stock Market, Retirement Planning, and Market Analysis. Each is edited by contributors
            with deep, specific expertise in that domain.
          </p>

          <h2 className="font-display text-3xl font-black mt-10 mb-4">AI-Assisted Editorial Process</h2>
          <p>
            Finance Topia uses large language models (currently Anthropic's Claude Sonnet 4.6)
            to accelerate the initial drafting of articles. Every draft is produced against our
            internal editorial prompt — modeled on the CFA Institute's standards of practice —
            which requires a beginner-first tone, a defined SEO keyword, specific numeric examples,
            named risks, and a step-by-step reader takeaway.
          </p>
          <p>
            AI drafting is a tool, not the whole process. Our editorial team reviews every article
            before publication, verifies data references against primary sources (Federal Reserve,
            Bureau of Labor Statistics, IMF, SEC), and refines the copy for accuracy and tone. No
            article is auto-published without editorial oversight.
          </p>
          <p>
            We disclose AI assistance on every article page and document our full editorial
            methodology on the{" "}
            <a href="/editorial" className="underline hover:text-primary">
              Editorial Team
            </a>{" "}
            page. Transparency about our process is a core part of the trust we're building with
            readers.
          </p>
        </div>
      </div>
    </>
  );
}
